/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  CREATE_SERVICE_CATALOG,
  READ_SERVICE_CATALOG,
  READ_SERVICE_CATALOG_LIST,
  SERVICE_CATALOG_PATH,
} from 'domain/shared/serviceCatalog';
import ServiceCatalogListPage from 'domain/organization/serviceCatalog/List';
import ServiceCatalogViewPage from 'domain/organization/serviceCatalog/Show';
import ServiceCatalogCreatePage from 'domain/organization/serviceCatalog/createupdate/Create';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import { BUDGETING_READ } from 'domain/organization/serviceCatalog/budgets/budgetingService';
import ViewServiceCostsStructure from 'domain/organization/serviceCatalog/budgets/structure/Show/ViewServiceCostsStructure';
import ServiceBudgetContext from 'domain/organization/serviceCatalog/ServiceBudgetContext';
import ServiceCatalogContext from 'domain/organization/serviceCatalog/ServiceCatalogContext';
import { KPI_STRUCTURE_READ, KPI_VALUES_READ_LIST } from './kpi/useKPIService';
import ViewKPIStructure from './kpi/Show/ViewKPIStructure';
import KpiValuesListPage from './kpi/List/KpiValuesListPage';

const useServiceCatalogRoute = () => {
  const routes = createRoute({ listRoute: SERVICE_CATALOG_PATH });

  return {
    ...routes,
    costsStructuresRoute: `${routes.singleEntityRoute}/costs/structures`,
    kpiStructureRoute: `${routes.singleEntityRoute}/kpi/structures/:timelineEntryId?`,
    kpiValueRoute: `${routes.singleEntityRoute}/kpi/values`,
  };
};

const ServiceCatalogRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createServiceCatalogRoute,
    costsStructuresRoute,
    kpiStructureRoute,
    kpiValueRoute,
  } = useServiceCatalogRoute();

  return (
    <ProtectedRouter basePath={SERVICE_CATALOG_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_SERVICE_CATALOG_LIST}>
              <ServiceCatalogListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={createServiceCatalogRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_SERVICE_CATALOG}>
              <ServiceCatalogCreatePage />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={costsStructuresRoute}
          element={
            <ServiceBudgetContext permissionToCheck={BUDGETING_READ}>
              <ViewServiceCostsStructure />
            </ServiceBudgetContext>
          }
        />
        <Route
          path={singleEntityRoute}
          element={
            <ServiceCatalogContext permissionToCheck={READ_SERVICE_CATALOG}>
              <ServiceCatalogViewPage />
            </ServiceCatalogContext>
          }
        />
        <Route
          path={kpiStructureRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={KPI_STRUCTURE_READ}>
              <ViewKPIStructure />
            </GlobalProtectedRoute>
          }
        />
        <Route
          path={kpiValueRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={KPI_VALUES_READ_LIST}>
              <KpiValuesListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
      </Routes>
    </ProtectedRouter>
  );
};

ServiceCatalogRouter.getRouterPath = () => `${SERVICE_CATALOG_PATH}/*`;

export default ServiceCatalogRouter;
